export const qaFile = (file) => {
   const GE_CT_QA = /SR\s\d{3}(\r\n|\r|\n)/g;
   const found = file.match(GE_CT_QA);
   const count = found.length;
   // console.log(`QA count: ${count}`);
};
